import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { IconSpinner } from '../../components';
import { fetchTriggerLog } from './AdminSocialPostsPage.duck';
import { decisionText, decisionTone, relTime } from './triggerLogCopy';
import css from './AdminSocialPostsPage.css';

/**
 * TriggerActivityPanel — the per-workflow "Aktivität" panel: the recent trigger
 * DECISIONS for one trigger (fired / suppressed / deduped / disabled / error), so a
 * manager can see WHY a pause→reactivate did or did not produce a post instead of a
 * silent gap. Fetched on expand; rows come from the SocialTriggerLogs audit table.
 */
const dotClass = tone =>
    tone === 'ok' ? css.actDotOk : tone === 'error' ? css.actDotError : css.actDotMuted;

const TriggerActivityPanelComponent = props => {
    const { slug, rows, loading, error, onFetch } = props;

    useEffect(() => {
        onFetch(slug);
    }, [slug, onFetch]);

    return (
        <div className={css.activityPanel}>
            {loading && !rows ? (
                <div className={css.activityLoading}>
                    <IconSpinner />
                </div>
            ) : error ? (
                <p className={css.activityEmpty}>Aktivität konnte nicht geladen werden.</p>
            ) : !rows || rows.length === 0 ? (
                <p className={css.activityEmpty}>Noch keine Aktivität.</p>
            ) : (
                <ul className={css.activityList}>
                    {rows.map(row => (
                        <li key={row.id} className={css.activityItem}>
                            <span
                                className={`${css.actDot} ${dotClass(decisionTone(row.decision))}`}
                                aria-hidden="true"
                            />
                            <span className={css.activityText}>{decisionText(row)}</span>
                            <span className={css.activityTime}>{relTime(row.createdAt)}</span>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

const mapStateToProps = (state, ownProps) => {
    const s = state.AdminSocialPostsPage;
    return {
        rows: s.triggerLogBySlug[ownProps.slug],
        loading: s.triggerLogLoadingSlugs.includes(ownProps.slug),
        error: s.triggerLogError,
    };
};

const mapDispatchToProps = dispatch => ({
    onFetch: slug => dispatch(fetchTriggerLog(slug)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TriggerActivityPanelComponent);
